import { type TopicPageProps } from "@op/puck-types";
import { Ow_ProjectCard, Ow_Topic_Hero } from "@op/sf-op";
import Medium from "../../../../../components/puck/Medium/Medium";
import { useMemo } from "react";
import { DefaultLinkComponent, ThemeNav } from "./ThemeNav";
import { ThemeFooter } from "./ThemeFooter";

const TopicPage = ({
  languageKey,
  pages,
  LinkComponent = DefaultLinkComponent,
  logoImage,
  languages,
  heading,
  subheading,
  topicSlug,
  imprintLink,
  privacyLink,
  copyrightText,
  hasImprint,
  hasPrivacyPolicy,
  organizationName,
  organizationLink,
}: TopicPageProps) => {
  const showHero = useMemo(
    () => !!heading || !!subheading,
    [heading, subheading],
  );

  return (
    <div className="min-h-screen flex flex-col justify-between items-center">
      <div className="w-full flex flex-col justify-center items-center">
        <ThemeNav
          languageKey={languageKey}
          languages={languages}
          logoImage={logoImage}
          organizationName={organizationName}
          organizationLink={organizationLink}
          LinkComponent={LinkComponent}
        />
        {showHero ? (
          <div className="flex flex-col w-full max-w-[1024px] mt-24 px-8 py-16">
            <Ow_Topic_Hero title={heading} description={subheading} />
          </div>
        ) : (
          <div className="h-32" />
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-8 max-w-[1024px] p-8">
          {pages.map((page) => (
            <LinkComponent
              to="/$languageKey/$topicSlug/$pageSlug"
              className="contents"
              key={page.id}
              params={{
                languageKey: languageKey,
                topicSlug: topicSlug,
                pageSlug: page.slug,
              }}
            >
              <Ow_ProjectCard
                className="max-w-[400px]"
                title={page.title ?? page.name}
                description={page.description}
                accent={false}
              >
                {page.image && <Medium cover medium={page.image} noContainer />}
              </Ow_ProjectCard>
            </LinkComponent>
          ))}
        </div>
      </div>
      <ThemeFooter
        copyrightText={copyrightText}
        imprintLink={imprintLink}
        privacyLink={privacyLink}
        hasImprint={hasImprint}
        hasPrivacyPolicy={hasPrivacyPolicy}
        languageKey={languageKey}
        LinkComponent={LinkComponent}
      />
    </div>
  );
};

export default TopicPage;
